/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SortOptions {
    ALPHABETICAL_UPWARDS = 'alphabetical-upwards',
    ALPHABETICAL_DOWNWARDS = 'alphabetical-downwards',
    LAST_APPOINTMENT_ASC = 'last-appointment-asc',
    LAST_APPOINTMENT_DESC = 'last-appointment-desc',
    BIRTHDATE_ASC = 'birthdate-asc',
    BIRTHDATE_DESC = 'birthdate-desc',
    CREATED_AT_ASC = 'created-at-asc',
    CREATED_AT_DESC = 'created-at-desc',
    AVERAGE_INTERVAL_ASC = 'average-interval-asc',
    AVERAGE_INTERVAL_DESC = 'average-interval-desc',
}
